import { render, staticRenderFns } from "./LeaveCodesList.vue?vue&type=template&id=6624a396&scoped=true&"
import script from "./LeaveCodesList.vue?vue&type=script&lang=js&"
export * from "./LeaveCodesList.vue?vue&type=script&lang=js&"
import style0 from "./LeaveCodesList.vue?vue&type=style&index=0&id=6624a396&lang=scss&scoped=true&"
import style1 from "./LeaveCodesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6624a396",
  null
  
)

export default component.exports